<template>
  <div v-if="value" class="residential-account-seller">
    <Avatar :value="value.avatar" size="large" />
    <div class="residential-account-seller__info">
      <span>{{ value.name }}</span>
      <template v-if="value.title">
        <span class="residential-account-seller__separator"></span>
        <span>{{ value.title }}</span>
      </template>
    </div>
    <div class="residential-account-seller__contact">
      <a :href="`mailto:${value.email}`"><FontAwesomeIcon :icon="['fal', 'envelope']" />{{ value.email }}</a>
      <a v-if="value.phone" :href="`tel:${value.phone}`"
        ><FontAwesomeIcon :icon="['fal', 'mobile']" />{{ value.phone }}</a
      >
    </div>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar'

export default {
  props: {
    value: Object,
  },
  components: {
    Avatar,
  },
}
</script>

<style lang="scss">
.residential-account-seller {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25em;

  &__info {
    font-weight: bold;
  }

  a {
    color: var(--primary);
    text-decoration: none;

    svg {
      margin-right: 5px;
    }
  }

  &__contact {
    display: flex;
    flex-direction: column;
    gap: 1em;
  }

  &__thumbnail {
    $size: 100px;
    width: $size;
    height: $size;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    flex-shrink: 0;
    background-size: cover;
    background-position: center;
    background-color: css-alpha('border-color', 0.4);
    border-radius: 50%;
    color: css-darken('border-color', 20%);
    margin-bottom: 0.5rem;
  }
}
</style>
